/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import Popover from '@react/react-spectrum/Popover';
import PropTypes from 'prop-types';
import React from 'react';
import './Pulse.scss';

export default function Pulse(props) {
  /**
   * When view all is pressed, call viewAll and close menu.
   * @param {string} activeTab Current active tab.
   */
  const onPulseViewAll = (activeTab) => {
    props.onViewAll(activeTab);
    props.closeMenu && props.closeMenu();
  };

  return (
    <Popover
      className="pulse-popover"
      isDialog={false}
      role="dialog"
      {...props}
      style={{...props.style, top: 40}}
    >
      {props.component.flyoutComponent(
        props.onUnreadChange, onPulseViewAll
      )}
    </Popover>
  );
}

Pulse.propTypes = {
  /** Function to close shell menu */
  closeMenu: PropTypes.func,
  /** Pulse component */
  component: PropTypes.object.isRequired,
  /** Function to update unread notifications */
  onUnreadChange: PropTypes.func.isRequired,
  /** Function to view all notifications */
  onViewAll: PropTypes.func.isRequired
};
